module.exports = __webpack_public_path__ + "img/global_rce_network.b55aad1e.png";